import axios from "axios";
import React, { useEffect, useState, useContext, useCallback } from "react";
import { Routes, Route, useParams, useSearchParams } from 'react-router-dom';
import SglContext from '../SglContext'
import Popup from 'reactjs-popup';
import { Link } from 'react-router-dom';

import VideoPlayer from "../videos/VideoPlayer";


// IMPORT IMAGES
import video_icon from "../images/video_icon.png";

function PeopleDetail(props) {
  const [personal_details, setPersonalDetails] = useState({})
  const [classes, setClasses] = useState([])
  const [videos_list, setVideosList] = useState([])
  const [shows_list, setShowsList] = useState([])
  const [currentShow, setCurrentShow] = useState(localStorage.getItem('show_id'))
  const [userData, setUserData] = useState({})
  const [is_videos_enabled, setIsVideosEnabled] = useState(false)
  const [video_to_play, setVideoToPlay] = useState({})
  const [playing_video, setPlayingVideo] = useState(false)
  const [is_open_play_video_modal, setIsOpenPlayVideoModal] = useState(false)
  const [is_open_do_subscription_modal, setIsOpenDoSubscriptionModal] = useState(false)
  const [is_admin, setIsAdmin] = useState(false)
  const [loading, setLoading] = useState(true)
  const [searchParams, setSearchParams] = useSearchParams()
  const Sgl = useContext(SglContext)
  const [VideoPlayerElement, setVideoPlayerElement] = useState(null);
  const [VideoSubscriptionElement, setVideoSubscriptionElement] = useState(null);

  const params = useParams()
 
  useEffect(() => {
    axios.get(Sgl.nestApiUrl + '/people/' + searchParams.get('pid'), {
      params: {
        pid: searchParams.get('pid'),
        show_id: searchParams.get('sid'),
        customer_id: Sgl.company_id,
      }
    }
    ).then(res => {
      setPersonalDetails(res.data.people);
      document.title = res.data.people.lf_name;

      setClasses(res.data.trips);
      setIsVideosEnabled(res.data.is_videos_enabled);
      setLoading(false)
    })
  }, [])
  useEffect(() => {
      axios.get(Sgl.nestApiUrl + '/people/videos/' + searchParams.get('pid'), {
        params: {
          pid: searchParams.get('pid'),
          show_id: searchParams.get('sid'),
          customer_id: Sgl.company_id
        }
      })
        .then((res) => {
          setVideosList(res.data.exc_videos);
          getUserData()
          
        // document.title = personal_details.lf_name;
        Sgl.reportToGA('/sgl-wp-plugin/'+Sgl.company_urlpath+'/'+currentShow+'/people/detail/'+searchParams.get('pid'));
        Sgl.reportToFB('/sgl-wp-plugin/'+Sgl.company_urlpath+'/'+currentShow+'/people/detail/'+searchParams.get('pid'));
        });
    }, [])
  function getUserData() {

    axios.get(Sgl.nestApiUrl +'/users/getUser')
      .then((response) => {
        if (response.data.user && response.data.user != null) {
          setUserData(response.data.user);
          if (localStorage.getItem('playing_video_id') && localStorage.getItem('playing_video_url') == window.location.pathname.replace(Sgl.basePath, '') + window.location.search) {
            playVideoAPICall(localStorage.getItem('playing_video_id'));
          }
        } else {
        }
      }, (error) => {
      });
  }
  function getVideosList(uuid) {
    var trip = videos_list.find(v => (v.uuid == uuid));
    if (trip) {
      var videos = trip.videos;
      return videos;
    }
    return [];
  }
  function playFirstVideoFromList(uuid){
    var trip = videos_list.find(v => (v.uuid == uuid));
    if(trip) {
      playVideoAPICall(trip.videos[0].sgl_id)
    }
    return;
  }
  function playVideo(video_id) {
    playVideoAPICall(video_id);
  }
  function playVideoAPICall(video_id) {
    localStorage.setItem('playing_video_id', video_id);
    localStorage.setItem('playing_video_url', window.location.pathname.replace(Sgl.basePath, '') + window.location.search);
    axios.get(Sgl.nestApiUrl + '/videos/play/' + video_id, {
      params: {
        // show_id: sgl_show_id,
        customer_id: Sgl.company_id
      }
    })
      .then((res) => {
        closeSubscriptionModal();
        localStorage.removeItem("playing_video_id");
        localStorage.removeItem("playing_video_url");
        if (res.data.subscribed_to_play) {
          setVideoToPlay(res.data.video);
          setIsAdmin(res.data.is_admin)
          setIsOpenPlayVideoModal(true);
          setPlayingVideo(true);
        } else {
          setVideoToPlay(res.data.video);
          setIsAdmin(res.data.is_admin)
          setIsOpenDoSubscriptionModal(true);
          setPlayingVideo(true);
        }
      });
  }
  function playVideoAfterSubscribe() {
    playVideoAPICall(video_to_play.videos_sgl_id);
    setPlayingVideo(true);
  }

  function closeModal() {
    setIsOpenPlayVideoModal(false);
    setPlayingVideo(false);
    
  }
  function closeSubscriptionModal() {
    setIsOpenDoSubscriptionModal(false);
    setPlayingVideo(false);
  }

  function getVideoTitle(video) {
    if (video['class_type'] == 'Jumpers') {
      if (video['trip_type'].toLowerCase() != 'jo') {
        return " - Round 1";
      } else {
        return " - Jump Off";
      }
    }
  }

  // function onShowChange(show_id) {
  //   localStorage.setItem('show_id', show_id);
  //   window.location.href = page_url;
  // }

  // render() {
  //   const loading = loading;
  //   const classes = classes.length;

    if (loading) {
      return null;
    }

  return (
    <div>
      <section className="search-area section-to-print">
      <h2 className="sgl-h2">{personal_details.lf_name}</h2>
      <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div><br />
      <table className="table contains-border">
        <thead className="people-detail-header">
          <tr className="sgl-primary-header">
            <th colspan="6">Personal Details</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th colspan="1" className="details-table-head">Name:</th>
            <td colspan="2">{(personal_details.lf_name) ? (personal_details.lf_name) : 'N/A'}</td>
          </tr>
          <tr>
            <th colspan="1" className="details-table-head">City, State:</th>
            <td colspan="2">
              {(personal_details.city) ? (personal_details.city) : 'N/A'}, {(personal_details.state) ? (personal_details.state) : 'N/A'}
            </td>
          </tr>
          <tr>
            <th colspan="1" className="details-table-head">Country:</th>
            <td colspan="2">{(personal_details.country) ? (personal_details.country) : 'N/A'}</td>
          </tr>
          <tr>
            <th colspan="1" className="details-table-head">USEF:</th>
            <td colspan="2">{(personal_details.usef) ? (personal_details.usef) : 'N/A'}</td>
          </tr>
          <tr>
            <th colspan="1" className="details-table-head">EC Sport Lic No.:</th>
            <td colspan="2">{(personal_details.ec_sport_license_type) ? (personal_details.ec_sport_license_type) : 'N/A'}</td>
          </tr>
        </tbody>
      </table>

      {(classes.length > 0) ?
        <div className="div-responsive">
          <table className="table table-striped">
            <thead className="classes-header">
              <tr className="sgl-primary-header">
                <th colspan="7">Classes</th>
              </tr>
            </thead>
            <tbody>
              <tr className="sgl-primary-header">
                {(is_videos_enabled == true) &&
                  <th nowrap="nowrap"></th>
                }
                <th className='center-align' nowrap="nowrap">Entry</th>
                <th nowrap="nowrap">Horse</th>
                <th nowrap="nowrap">Rider</th>
                <th nowrap="nowrap">Class</th>
                <th className='center-align' nowrap="nowrap">Count</th>
                <th className='center-align' nowrap="nowrap">Placing</th>
              </tr>
              {
                classes.map((data, index) => {
                  return (

                    <tr key={index} className='sgl-anchor'>
                      {(is_videos_enabled == true) &&
                        <td><a>
                          {(getVideosList(data.entryxclasses_uuid).length > 0) ?
                          // <div>abc<div/>
                            <Popup trigger={<img src={video_icon} className="video-icon" onClick={()=>playFirstVideoFromList(data.entryxclasses_uuid)}/>} on="hover" position="right center">
                              <div>
                                <ul className='popup-ul'>
                                  {getVideosList(data.entryxclasses_uuid).map((v_data, index) => {
                                    return (
                                      <li key={index} className='class_list_li'>
                                        <a onClick={()=>playVideo(v_data.sgl_id)}>
                                          {v_data.class_number} - {v_data.class_name}{getVideoTitle(v_data)}
                                        </a>
                                        </li>
                                    )
                                  })}
                                </ul>
                              </div>
                            </Popup>
                            :
                            ''
                          }
                        </a></td>
                      }
                      <td><Link to={'/entries/detail?eid=' + data.entry_id + '&sid=' + currentShow}>{data.entry_number}</Link></td>
                      <td><Link to={'/entries/detail?eid=' + data.entry_id + '&sid=' + currentShow}>{data.horse}</Link></td>
                      {/* <td>{data.rider_name}</td> */}
                      <td><Link to={"/people/detail/" + '?pid=' + data.rider_id + '&sid=' + currentShow}>{data.rider_name}</Link></td>
                      <td><Link to={'/classes/detail?cid=' + data.class_id + '&sid=' + currentShow}>
                        {data.class_number} - {data.class_name}
                        {(data.sponsor) &&
                          <span className='sponsor_text'><br />(Sponsored By:{data.sponsor})</span>
                        }
                      </Link></td>
                      <td className='center-align'><a>{data.trips_count}</a></td>
                      <td className='center-align'><a>{data.placing}</a></td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>

        : <span>No classes found. </span>
      }
      <div>
      
        {(playing_video) &&
          <VideoPlayer
            is_open_play_video_modal={is_open_play_video_modal}
            company_id = {Sgl.company_id}
            is_open_do_subscription_modal={is_open_do_subscription_modal}
            is_download_subscription={false}
            video_to_play={video_to_play}
            is_admin={is_admin}
            closeModal={closeModal}
            closeSubscriptionModal={closeSubscriptionModal}
            playing_preview={false}
            play_video_path={video_to_play.video_url}
            playVideoAfterSubscribe={playVideoAfterSubscribe}
            VideoSubscriptionElement={VideoSubscriptionElement}
            ref={VideoPlayerElement}
          />
        }
      </div>
      <div className="copyright-text">{process.env.REACT_APP_COPYRIGHT_TEXT}</div>
      </section>
    </div>
  )
}
export default PeopleDetail